export const rePhoneNumber = /\d{2}[\d\s]+$/;
